import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useMessenger } from "./MessengerContext";
import { ThemeContext } from "./theme";
import s7Image from "../Images/photos/s7.png";
import { Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { apiFetch } from "../context/AuthContext";

// الصفحات
import EmployeesTableadmin from "./EmployeeTable";

import EmployeesTable from "./EmployeeTableManager.js";
import Dashboard from "./dashboard_Final/index.js";
import Analytics from "./ComingSoon_Final/ComingSoon.js";
import Reports from "./Reports_Final/Reports.js";
import Connectors from "./ConnectorsPage_user.js";
import Calendar from "./Calendar";
import Attendance from "./Attendance";
import SettingsPage from "./settings_Final/settings.js";
import Mo3tiAdminDocumentRequests from "./Mo3tiAdminDocumentRequests";
import ExcelSalaryProcessorWithTheme from "./TaxCalc";
import Payroll from "./payroll.js";
import SidebarWithTopbar from "./sidebar4";
import ViewTypeSwitcher from '../components/ViewTypeSwitcher';
import Mo3tiAdvancementManagement from "./mo3tiAdvanceRequest.js";
import LeaveApprovalPage from "./adminLeavePage.js";
import MessengerPage from "./MessagesPage.jsx";
import EmployeeActionsPage from "./changesPage.js";
import CompanyConfiguration from "./CompanyConfiguration";
import { LanguageContext } from "./LanguageContext";
import { useModal } from '../constant/ModalContext.jsx';
import { translations_Manager } from "../constant/(Admin)Translations.js"; 
import {
  User,
  MessageSquare,
  LogOut,
  Bell,
  Plug,
  MapPinOff,
  Network,
  Settings,
  BarChart3,
  CalendarCheck,
  Users,
  CalculatorIcon,
  RefreshCcw,
  Calendar as CalendarIcon,
  FileText,
  Home,
  CreditCard,
  Sun,
  Moon,
  Calculator,
  GitPullRequestIcon,
  BookCheckIcon,
  DollarSignIcon,
  Coffee,
  LockIcon,
  GitPullRequest,
  Shield
} from "lucide-react";

// الترجمة العربية


const allowedArea = {
  lat: process.env.REACT_APP_OFFICE_LATITUDE,
  lng: process.env.REACT_APP_OFFICE_LONGITUDE,
  radius: 10000, // بالمتر (10 كم حول النقطة)
};
// دالة مساعدة: حساب المسافة بين نقطتين (صيغة Haversine)
function getDistance(lat1, lon1, lat2, lon2) {
  const R = 6371000; // نصف قطر الأرض بالمتر
  const toRad = (deg) => (deg * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
    Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // المسافة بالمتر
}

const normalizeEmployeeState = (employee) => {
  const raw = employee?.employeeState ?? employee?.status ?? employee?.state ?? "";
  const value = typeof raw === "string" ? raw : String(raw || "");
  return value.trim().toLowerCase().replace(/\s+/g, "");
};

const extractCompanyName = (employee) => {
  const source =
    employee?.workingCompany ??
    employee?.company ??
    employee?.contractCompany ??
    "";
  if (typeof source === "string") {
    const trimmed = source.trim();
    return trimmed.length ? trimmed : "";
  }
  return String(source || "").trim();
};

const safeDecodeToken = (token) => {
  try {
    if (!token) return null;
    const segments = token.split(".");
    if (segments.length < 2) return null;
    let payload = segments[1].replace(/-/g, "+").replace(/_/g, "/");
    const pad = payload.length % 4;
    if (pad) {
      payload += "=".repeat(4 - pad);
    }
    const decoder =
      (typeof window !== "undefined" && typeof window.atob === "function")
        ? window.atob
        : (typeof atob === "function" ? atob : null);
    if (!decoder) return null;
    const json = decoder(payload);
    return JSON.parse(json);
  } catch (error) {
    console.warn("safeDecodeToken failed:", error);
    return null;
  }
};

const normalizeCodeValue = (value) => {
  if (value === null || value === undefined) return "";
  const raw = typeof value === "number" ? String(value) : String(value || "");
  const compact = raw.trim().replace(/\s+/g, "");
  if (!compact) return "";
  if (/^\d+$/.test(compact)) {
    const stripped = compact.replace(/^0+/, "");
    return stripped.length ? stripped : "0";
  }
  return compact;
};

const collectHierarchyEmployees = (payload, managerInfinityCode) => {
  const visited = new Set();
  const results = [];
  const managerCodeNormalized = normalizeCodeValue(managerInfinityCode);

  const enqueueChildren = (possibleChildren) => {
    if (!possibleChildren) return [];
    if (Array.isArray(possibleChildren)) return possibleChildren;
    if (typeof possibleChildren === "object") {
      if (Array.isArray(possibleChildren.data)) {
        return possibleChildren.data;
      }
      if (Array.isArray(possibleChildren.items)) {
        return possibleChildren.items;
      }
    }
    return [];
  };

  const collect = (node) => {
    if (!node || typeof node !== "object") return;

    const primaryCode =
      node.infinityCode ??
      node.infinity_code ??
      node.code ??
      node.employeeCode ??
      node.id ??
      node.employeeId ??
      null;

    const normalizedCode = normalizeCodeValue(primaryCode);

    const shouldInclude =
      normalizedCode &&
      (!managerCodeNormalized || normalizedCode !== managerCodeNormalized);

    if (shouldInclude && !visited.has(normalizedCode)) {
      visited.add(normalizedCode);
      results.push(node);
    }

    const childCandidates = [
      node.children,
      node.subordinates,
      node.directReports,
      node.employees,
      node.nodes,
      node.hierarchy,
      node.reports,
    ];

    childCandidates.forEach((childSet) => {
      const queue = enqueueChildren(childSet);
      queue.forEach((child) => collect(child));
    });
  };

  const initialCollections = enqueueChildren(payload);
  if (Array.isArray(payload?.hierarchy)) {
    initialCollections.push(...payload.hierarchy);
  }
  if (Array.isArray(payload?.data?.hierarchy)) {
    initialCollections.push(...payload.data.hierarchy);
  }

  if (initialCollections.length === 0 && payload && typeof payload === "object") {
    collect(payload);
  } else {
    initialCollections.forEach((node) => collect(node));
  }

  return results;
};

const extractEmployeesFromPayload = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.employees)) return payload.employees;
  if (payload.data) {
    if (Array.isArray(payload.data)) return payload.data;
    if (Array.isArray(payload.data.employees)) return payload.data.employees;
  }
  return [];
};

const COLOR_PALETTE = ["#10b981", "#3b82f6", "#8b5cf6", "#f59e0b", "#ef4444"];

const buildDepartmentStatsFromEmployees = (employees, totalOverride) => {
  const departmentCounts = new Map();

  employees.forEach((emp) => {
    const source =
      emp?.department ??
      emp?.departmentName ??
      emp?.department_name ??
      emp?.employeeType ??
      emp?.dept ??
      emp?.Team ??
      emp?.team ??
      "Unassigned";

    const name = (() => {
      if (typeof source === "string") {
        const trimmed = source.trim();
        return trimmed.length ? trimmed : "Unassigned";
      }
      const value = String(source || "").trim();
      return value.length ? value : "Unassigned";
    })();

    departmentCounts.set(name, (departmentCounts.get(name) || 0) + 1);
  });

  const total = totalOverride ?? employees.length;

  return Array.from(departmentCounts.entries())
    .map(([name, count], index) => ({
      name,
      count,
      percentage: total > 0 ? Math.round((count / total) * 100) : 0,
      color: COLOR_PALETTE[index % COLOR_PALETTE.length],
    }))
    .filter((item) => item.count > 0);
};

const mapDepartmentStatsResponse = (rawStats, totalEmployees) => {
  const candidates = (() => {
    if (!rawStats) return [];
    if (Array.isArray(rawStats)) return rawStats;
    if (Array.isArray(rawStats.data)) return rawStats.data;
    if (Array.isArray(rawStats.departments)) return rawStats.departments;
    if (Array.isArray(rawStats.stats)) return rawStats.stats;
    return [];
  })();

  if (!candidates.length) return [];

  const safeTotal = totalEmployees > 0 ? totalEmployees : candidates.reduce((sum, item) => {
    const count = Number(
      item.count ??
      item.total ??
      item.employeeCount ??
      item.employees ??
      item.value
    ) || 0;
    return sum + count;
  }, 0);

  return candidates
    .map((item, index) => {
      const count = Number(
        item.count ??
        item.total ??
        item.employeeCount ??
        item.employees ??
        item.value
      ) || 0;
      const name =
        item.name ??
        item.department ??
        item.departmentName ??
        item.label ??
        item.id ??
        "Unassigned";

      return {
        name,
        count,
        percentage: safeTotal > 0 ? Math.round((count / safeTotal) * 100) : 0,
        color: COLOR_PALETTE[index % COLOR_PALETTE.length],
      };
    })
    .filter((stat) => stat.count > 0);
};

function ProfessionalDashboardManager() {
  // سياق الثيم
  const { theme, setTheme } = useContext(ThemeContext);

  // اللغة الحالية
  const { language = 'en' } = useContext(LanguageContext);
  const isRTL = language === 'ar';
  const t = translations_Manager[language] || translations_Manager['ar'];
  // حالة الموقع
  const [userLocation, setUserLocation] = useState(null);
  const [locationError, setLocationError] = useState(null);
  const [modulePermissions, setModulePermissions] = useState(null);
  const [loadingPermissions, setLoadingPermissions] = useState(true);
  // جلب موقع المستخدم عند التحميل
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setUserLocation({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        },
        (err) => {
          console.error("خطأ في الحصول على الموقع:", err);
          setLocationError(t.locationAccessDenied);
        }
      );
    } else {
      setLocationError("خاصية تحديد الموقع غير مدعومة في هذا المتصفح.");
    }
  }, []);

  const [employeeCount, setEmployeeCount] = useState(0);
  const [counts, setCounts] = useState({ Active: 0, OnLeave: 0, Recent: 0, TotalCompanies: 0 });
  const [departmentStats, setDepartmentStats] = useState([]);
  const [viewType, setViewType] = useState(() => {
    return localStorage.getItem('managerViewType') || 'manager';
  });

  useEffect(() => {
    try {
      const storedRole = (localStorage.getItem('role') || '').toLowerCase();
      const adminLevelRaw = localStorage.getItem('adminLevel');
      let hasAdmin = false;

      if (adminLevelRaw) {
        try {
          const parsed = JSON.parse(adminLevelRaw);
          hasAdmin = Boolean(
            parsed?.adminLevelId ||
            parsed?.admin_level_id ||
            (Array.isArray(parsed?.modules) && parsed.modules.length > 0)
          );
        } catch (parseError) {
          console.warn('Failed to parse admin level during view enforcement:', parseError);
        }
      }

      if (storedRole === 'manager' && !hasAdmin) {
        if (localStorage.getItem('managerViewType') !== 'manager') {
          localStorage.setItem('managerViewType', 'manager');
          localStorage.setItem('viewType', 'manager');
        }
        setViewType('manager');
      }
    } catch (error) {
      console.warn('Failed to enforce default manager view:', error);
    }
  }, []);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    let canceled = false;

    const fetchMetrics = async () => {
      try {
        if (!BASE_URL) return;

        const token = localStorage.getItem("token");
        if (!token) return;

        const payload = safeDecodeToken(token) || {};
        const roleCandidates = [
          payload.role,
          payload.Role,
          localStorage.getItem("role"),
          localStorage.getItem("userRole"),
        ].filter((value) => typeof value === "string" && value.trim().length > 0);

        const normalizedRole = roleCandidates.length
          ? String(roleCandidates[0]).trim().toLowerCase()
          : "";

        const managerInfinityCode =
          payload.infinityCode || localStorage.getItem("infinityCode") || "";
        const clientNameRaw =
          localStorage.getItem("clientName") ||
          payload.clientName ||
          payload.client ||
          payload.companyName ||
          "Infinity";
        const clientName =
          typeof clientNameRaw === "string" && clientNameRaw.trim().length
            ? clientNameRaw.trim()
            : "Infinity";
        const encodedClientName = encodeURIComponent(clientName);
        const adminViewActive = viewType === "admin" && hasAdminLevel();
        const shouldUseHierarchy =
          !adminViewActive && (normalizedRole === "manager" || viewType === "manager");

        if (adminViewActive && normalizedRole === "manager") {
          const adminLevelRaw = localStorage.getItem("adminLevel");
          let visibilityClientName = clientName;

          if (adminLevelRaw) {
            try {
              const parsedAdminLevel = JSON.parse(adminLevelRaw);
              if (parsedAdminLevel?.clientName) {
                visibilityClientName = parsedAdminLevel.clientName;
              }
            } catch (parseError) {
              console.warn("Failed to parse admin level for visibility fetch:", parseError);
            }
          }

          const query = visibilityClientName
            ? `?clientName=${encodeURIComponent(visibilityClientName)}`
            : "";

          const visibilityResponse = await apiFetch(
            `${BASE_URL}/employees/visibility${query}`,
            { method: "GET", headers: { "x-view-type": "admin" } }
          );

          if (!visibilityResponse.ok) {
            throw new Error("Failed to fetch visibility-scoped employees for admin view");
          }

          const visibilityPayload = await visibilityResponse.json();
          const visibleEmployees = extractEmployeesFromPayload(visibilityPayload);

          if (canceled) return;

          const activeCount = visibleEmployees.filter(
            (emp) => normalizeEmployeeState(emp) === "active"
          ).length;
          const onLeaveCount = visibleEmployees.filter(
            (emp) => normalizeEmployeeState(emp) === "onleave"
          ).length;
          const companies = new Set(
            visibleEmployees.map(extractCompanyName).filter(Boolean)
          );
          const totalCompaniesCount = companies.size || (visibleEmployees.length ? 1 : 0);

          setEmployeeCount(visibleEmployees.length);
          setCounts({
            Active: activeCount,
            OnLeave: onLeaveCount,
            Recent: 0,
            TotalCompanies: totalCompaniesCount,
          });
          setDepartmentStats(
            buildDepartmentStatsFromEmployees(visibleEmployees, visibleEmployees.length)
          );
          return;
        }

        if (shouldUseHierarchy) {
          if (!managerInfinityCode) {
            if (!canceled) {
              setEmployeeCount(0);
              setCounts({ Active: 0, OnLeave: 0, Recent: 0, TotalCompanies: 0 });
              setDepartmentStats([]);
            }
            return;
          }

          const hierarchyUrl = `${BASE_URL}/employees/clients/${encodedClientName}/hierarchy?managerInfinityCode=${encodeURIComponent(managerInfinityCode)}`;
          const hierarchyResponse = await apiFetch(hierarchyUrl, { method: "GET" });

          if (!hierarchyResponse.ok) {
            throw new Error("Failed to fetch manager hierarchy data");
          }

          const hierarchyPayload = await hierarchyResponse.json();
          const subordinates = collectHierarchyEmployees(
            hierarchyPayload,
            managerInfinityCode
          );

          console.log(`👥 Manager hierarchy employees resolved: ${subordinates.length}`);

          if (canceled) return;

          const activeCount = subordinates.filter(
            (emp) => normalizeEmployeeState(emp) === "active"
          ).length;
          const onLeaveCount = subordinates.filter(
            (emp) => normalizeEmployeeState(emp) === "onleave"
          ).length;
          const companies = new Set(subordinates.map(extractCompanyName).filter(Boolean));
          const totalCompaniesCount = companies.size || (subordinates.length ? 1 : 0);

          setEmployeeCount(subordinates.length);
          setCounts({
            Active: activeCount,
            OnLeave: onLeaveCount,
            Recent: 0,
            TotalCompanies: totalCompaniesCount,
          });
          setDepartmentStats(buildDepartmentStatsFromEmployees(subordinates, subordinates.length));
          return;
        }

        const isInfinityClient = clientName.toLowerCase() === "infinity";

        const employeeCountUrl = isInfinityClient
          ? `${BASE_URL}/employees/count`
          : `${BASE_URL}/employees/client/${encodedClientName}/count`;
        const activeUrl = isInfinityClient
          ? `${BASE_URL}/employees/Active`
          : `${BASE_URL}/employees/client/${encodedClientName}/Active`;
        const onLeaveUrl = isInfinityClient
          ? `${BASE_URL}/employees/OnLeave`
          : `${BASE_URL}/employees/client/${encodedClientName}/OnLeave`;
        const deptStatsUrl = isInfinityClient
          ? `${BASE_URL}/employees/departments/stats`
          : `${BASE_URL}/employees/client/${encodedClientName}/departments/stats`;

        const [employeeCountRes, activeRes, onLeaveRes, deptStatsRes] = await Promise.all([
          apiFetch(employeeCountUrl, { method: "GET" }),
          apiFetch(activeUrl, { method: "GET" }),
          apiFetch(onLeaveUrl, { method: "GET" }),
          apiFetch(deptStatsUrl, { method: "GET" }),
        ]);

        if (!employeeCountRes.ok || !activeRes.ok || !onLeaveRes.ok || !deptStatsRes.ok) {
          throw new Error("Failed to fetch dashboard metrics");
        }

        const [employeeCountData, activeData, onLeaveData, deptStatsData] = await Promise.all([
          employeeCountRes.json(),
          activeRes.json(),
          onLeaveRes.json(),
          deptStatsRes.json(),
        ]);

        if (canceled) return;

        const totalCount = Number(employeeCountData?.count) || 0;

        setEmployeeCount(totalCount);
        setCounts((prev) => ({
          Active: Number(activeData?.count) || 0,
          OnLeave: Number(onLeaveData?.count) || 0,
          Recent: 7,
          TotalCompanies:
            prev?.TotalCompanies && prev.TotalCompanies > 0
              ? prev.TotalCompanies
              : totalCount > 0
                ? 1
                : 0,
        }));
        setDepartmentStats(mapDepartmentStatsResponse(deptStatsData, totalCount));
      } catch (error) {
        console.error("Error fetching dashboard metrics:", error);
        if (!canceled) {
          setDepartmentStats([]);
        }
      }
    };

    fetchMetrics();
    return () => {
      canceled = true;
    };
  }, [BASE_URL, viewType]);



  // معلومات المستخدم من localStorage
  const [user] = useState({
    username: localStorage.getItem("emoloyeeName"),
    email: localStorage.getItem("email"),
    role: localStorage.getItem("role"),
  });

  const [notifications, setNotifications] = useState(3);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [unreadMessages, setUnreadMessages] = useState(0);

  // Call hooks at top level before useEffect
  const navigate = useNavigate();
  const auth = useAuth();
  const { conversations: messengerConversations, socket, isConnected } = useMessenger();
  const { logout, hasModuleAccess } = auth;
  const { showModal } = useModal();

  // If MessengerContext already has conversations loaded (Messages page), use that as the primary source
  useEffect(() => {
    try {
      if (Array.isArray(messengerConversations) && messengerConversations.length > 0) {
        const totalFromContext = messengerConversations.reduce((s, c) => {
          const u = c.unread ?? c.unreadCount ?? c.unread_count ?? c.unreads ?? 0;
          return s + (Number(u) || 0);
        }, 0);
        console.log('[DashboardManager] Using MessengerContext unread total:', totalFromContext);
        setUnreadMessages(totalFromContext);
      }
    } catch (err) {
      console.warn('[DashboardManager] Error computing unread from MessengerContext', err);
    }
  }, [messengerConversations]);

  // Reset currentPage when viewType changes
  useEffect(() => {
    setCurrentPage('dashboard');

    // Debug: Log admin level info when switching to admin view
    if (viewType === 'admin') {
      console.log('🔐 Admin View Mode Active');
      console.log('Admin Level Data (raw):', localStorage.getItem('adminLevel'));
      try {
        const adminLevel = JSON.parse(localStorage.getItem('adminLevel'));
        console.log('Parsed Admin Level:', adminLevel);
        console.log('Available Modules:', adminLevel?.modules);
        console.log('Module names:', adminLevel?.modules?.map(m => m.moduleName || m.name || m));
      } catch (e) {
        console.error('Error parsing adminLevel:', e);
      }

      // Also check what AuthContext sees
      console.log('AuthContext permissions:', auth.permissions);
      console.log('AuthContext user:', auth.user);
    }
  }, [viewType, auth]);

  const handleViewTypeChange = (type) => {
    setViewType(type);

    try {
      if (type) {
        localStorage.setItem('managerViewType', type);
        localStorage.setItem('viewType', type);
      }
    } catch (error) {
      console.warn('Failed to persist view type selection:', error);
    }

    if (type === 'user') {
      // Check if user has admin level AND role is admin - if yes, go to userprofileadmin, otherwise go to userprofilemanager
      if (hasAdminLevel() && user.role === 'admin') {
        navigate("/userprofileadmin/professionalProfile");
      }
      else if (hasAdminLevel() && user.role === 'manager') {
        navigate("/userprofilemanager/professionalProfile");
      }
      else {
        navigate("/userprofilemanager/professionalProfile");
      }
    } else if (type === 'manager') {
      // Reset to dashboard in manager view
      setCurrentPage('dashboard');
    } else if (type === 'admin') {
      // Reset to dashboard in admin view
      setCurrentPage('dashboard');
      navigate("/DashboardManager/dashboard");
    }
  };

  // Check if user has an admin level assigned
  const hasAdminLevel = () => {
    try {
      const adminLevelData = localStorage.getItem('adminLevel');
      if (adminLevelData) {
        const adminLevel = JSON.parse(adminLevelData);
        return adminLevel && (adminLevel.modules?.length > 0 || adminLevel.adminLevelId);
      }
    } catch (e) {
      console.error('Error checking admin level:', e);
    }
    return false;
  };

  // التبديل بين الثيم الفاتح والداكن
  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
  };

  // جلب صلاحيات الوحدات
  useEffect(() => {
    const fetchModulePermissions = async () => {
      try {
        const clientName = localStorage.getItem("clientName", "");
        if (!clientName) {
          setLoadingPermissions(false);
          return;
        }

        const response = await apiFetch(
          `${BASE_URL}/api/configurations/${encodeURIComponent(clientName)}`,
          { method: "GET" }
        );
        const json = await response.json();

        if (json && json.data) {
          setModulePermissions(json.data);
        } else {
          setModulePermissions({ privateMessaging: false });
        }
      } catch (error) {
        console.error("خطأ في جلب صلاحيات الوحدات:", error);
        setModulePermissions({ privateMessaging: false });
      } finally {
        setLoadingPermissions(false);
      }
    };

    fetchModulePermissions();
  }, [BASE_URL]);

  // جلب عدد الرسائل غير المقروءة (مرة واحدة فقط عند التحميل)
  useEffect(() => {
    const fetchUnreadMessages = async () => {
      try {
        if (!BASE_URL) {
          console.log('[DashboardManager] BASE_URL not set');
          return;
        }

        console.log('[DashboardManager] Fetching initial unread count from:', `${BASE_URL}/api/private-messages/conversations`);
        
        const response = await apiFetch(
          `${BASE_URL}/api/private-messages/conversations`,
          { method: 'GET' }
        );

        console.log('[DashboardManager] Response status:', response.status, response.ok);

        if (response.ok) {
          const data = await response.json();
          console.log('[DashboardManager] Raw API Response:', data);
          
          // البيانات قد تأتي كـ array مباشرة أو داخل object
          let conversations = [];
          if (Array.isArray(data)) {
            conversations = data;
          } else if (data.data && Array.isArray(data.data)) {
            conversations = data.data;
          } else if (data.conversations && Array.isArray(data.conversations)) {
            conversations = data.conversations;
          }
          
          console.log('[DashboardManager] Parsed conversations array length:', conversations.length);
          
          // حساب إجمالي الرسائل غير المقروءة
          let total = 0;
          conversations.forEach((conv, index) => {
            // البحث عن unreadCount بطرق مختلفة
            const unreadCount = 
              conv.unreadCount ?? 
              conv.unread_count ?? 
              conv.unreadMessagesCount ?? 
              conv.unreads ?? 
              0;
            
            total += Number(unreadCount) || 0;
            
            if (index < 3) { // لا نطبع جميعها، فقط أول 3
              console.log(`[DashboardManager] Conversation: "${conv.recipientName || conv.name || 'Unknown'}" - Unread: ${unreadCount}`);
            }
          });

          console.log('[DashboardManager] ✅ Initial unread messages count:', total);
          setUnreadMessages(total);
        } else {
          console.error('[DashboardManager] ❌ API returned error status:', response.status, await response.text());
        }
      } catch (error) {
        console.error('[DashboardManager] ❌ Error fetching unread messages:', error);
      }
    };

    fetchUnreadMessages();
    // No polling - we'll use real-time socket events instead
  }, [BASE_URL]);

  // Real-time socket listener for new messages
  useEffect(() => {
    if (!socket || !isConnected) {
      console.log('[DashboardManager] Socket not ready for unread messages listener');
      return;
    }

    console.log('[DashboardManager] Setting up real-time message listeners');

    // Increment counter when new message is received
    const handleMessageReceived = (data) => {
      console.log('[DashboardManager] 📩 New message received:', data);
      setUnreadMessages(prev => {
        const newCount = prev + 1;
        console.log(`[DashboardManager] Unread count: ${prev} → ${newCount}`);
        return newCount;
      });
    };

    // Decrement counter when messages are marked as read
    const handleMessagesRead = (data) => {
      console.log('[DashboardManager] ✓ Messages marked as read:', data);
      if (data.count) {
        setUnreadMessages(prev => {
          const newCount = Math.max(0, prev - data.count);
          console.log(`[DashboardManager] Unread count: ${prev} → ${newCount}`);
          return newCount;
        });
      }
    };

    socket.on('private_message:received', handleMessageReceived);
    socket.on('private_message:read', handleMessagesRead);

    console.log('[DashboardManager] ✅ Real-time message listeners active');

    return () => {
      socket.off('private_message:received', handleMessageReceived);
      socket.off('private_message:read', handleMessagesRead);
      console.log('[DashboardManager] Cleaned up message listeners');
    };
  }, [socket, isConnected]);

  const isPrivateMessagingEnabled = modulePermissions?.privateMessaging ?? false;

  // دالة تسجيل الخروج
  const handleLogout = () => {
    try {
      logout();
      try {
        localStorage.removeItem('nav_admin');
        localStorage.removeItem('nav_manager');
        localStorage.removeItem('nav_employee');
      } catch (e) { }
      navigate("/login");
    } catch (error) {
      console.error("خطأ في تسجيل الخروج:", error);
      navigate("/login");
    }
  };

  // التبديل إلى حساب الموظف
  const handleSwitchEmployee = () => {
    try {
      localStorage.removeItem('adminCurrentPage');
      setCurrentPage('dashboard');
      navigate("/userprofilemanager/professionalProfile");
    } catch (error) {
      console.error("خطأ في التبديل:", error);
      navigate("/DashboardManager");
    }
  };

  // تغيير الصفحة الحالية
  const handlePageChange = (page) => {
    const navItem = navItems.find(item => item.page === page);
    if (navItem?.locked) {
      const title = (t && t.notice) || 'Notice';
      const message = navItem.lockMessage || undefined; // allow ModalContext to use localized default
      showModal({ title, message, options: { requestAccessEndpoint: process.env.REACT_APP_BASE_URL ? `${process.env.REACT_APP_BASE_URL}/api/request-module-access` : null, module: navItem.page } });
      return;
    }
    setCurrentPage(page);
    navigate(`/DashboardManager/${page}`);
  };

  // Mapping between page names and module names for permission checking
  const pageToModuleMap = {
    "dashboard": null, // Dashboard is always visible
    "employees": "employees",
    "attendance": "attendance",
    "reports": "reports",
    "calendar": "calendar",
    "messages": "messages",
    "Mo3tiAdminDocumentRequests": "documents",
    "LeaveApprovalPage": "leaves",
    "Mo3tiAdvancementManagement": "advancements",
    "ChangesPage": "changesPage", // Employee changes uses separate changesPage module
    "Payroll": "payroll",
    "TaxCalculator": "payroll", // Tax calculator is part of payroll
    "companyConfig": "configurations", // Company Configuration - accessible by admin levels
    "Settings": null,
  };

  // Pages that should only appear in Admin View (not in Manager View)
  const adminOnlyPages = ["Payroll", "companyConfig"];

  // عناصر قائمة التنقل
  const allNavItems = [
    { icon: Home, text: t.dashboard, page: "dashboard" },
    { icon: Users, text: t.employees, page: "employees" },
    { icon: CalendarCheck, text: t.attendance, page: "attendance" },
    // { icon: FileText, text: t.reports, page: "reports" },
    { icon: CalendarIcon, text: t.calendar, page: "calendar" },
    {
      icon: MessageSquare,
      text: isPrivateMessagingEnabled ? t.messages : t.messagesLocked,
      page: "messages",
      locked: !isPrivateMessagingEnabled,
      badge: unreadMessages,
      badgeColor: '#ef4444',
    },
    // Documents nav item — visibility is controlled by admin-view permission checks
    { icon: BookCheckIcon, text: t.documentsManagement, page: "Mo3tiAdminDocumentRequests" },
    { icon: Coffee, text: t.leaveManagement, page: "LeaveApprovalPage" },
    { icon: DollarSignIcon, text: t.solfaManagement, page: "Mo3tiAdvancementManagement" },
    { icon: GitPullRequestIcon, text: t.employeeChanges, page: "ChangesPage" },
    { icon: CreditCard, text: t.payroll, page: "Payroll" },
    { icon: CalculatorIcon, text: t.taxCalculator, page: "TaxCalculator" },
    { icon: LockIcon, text: t.companyConfiguration, page: "companyConfig" },
    { icon: Settings, text: t.settingsLocked, page: "Settings" },
  ];

  // Filter navigation items based on viewType
  const navItems = allNavItems.filter(item => {
    // Dashboard and Settings are always visible
    if (item.page === "dashboard" || item.page === "Settings") return true;

    // Super admins see everything
    if (user.role === "superadmin") return true;

    // Admin-only pages: hide in user/manager view
    if (adminOnlyPages.includes(item.page) && (viewType === 'user' || viewType === 'manager')) {
      return false;
    }

    // If in user view, hide all pages except dashboard and settings
    if (viewType === 'user') {
      return false;
    }

    // If in manager view, show all standard manager items (except admin-only pages)
    if (viewType === 'manager') {
      return !adminOnlyPages.includes(item.page);
    }

    // If in admin view mode, filter based on admin level permissions
    if (viewType === 'admin') {
      // Get the required module for this page
      const requiredModule = pageToModuleMap[item.page];

      // If no module mapping exists, show the item (backward compatibility)
      if (!requiredModule) return true;

      // Check if user has access to the required module
      const hasAccess = hasModuleAccess(requiredModule);
      console.log(`Admin Mode - Page: ${item.page}, Module: ${requiredModule}, Access: ${hasAccess}`);
      return hasAccess;
    }

    return true;
  });

  // دوال العرض لجميع الصفحات
  const renderDashboard = () => (
    <Dashboard
      employeeCount={employeeCount}
      counts={counts}
      departmentStats={departmentStats}
    />
  );
  const renderEmployees = () => {
    // If in admin view, show admin employees table, otherwise show manager employees table
    if (viewType === 'admin') {
      return <EmployeesTableadmin />;
    }

    return (
      <EmployeesTable
        onCountsUpdate={(updatedCounts) => {
          if (updatedCounts && typeof updatedCounts === "object") {
            setCounts((prev) => ({ ...prev, ...updatedCounts }));
          }
        }}
        onEmployeeCountUpdate={(total) => {
          if (typeof total === "number") {
            setEmployeeCount(total);
          }
        }}
      />
    );
  };
  const renderAttendance = () => <Attendance />;
  const renderAnalytics = () => <Analytics />;
  const renderReports = () => <Reports />;
  const renderMessages = () => <MessengerPage />;
  const renderCalendar = () => <Calendar />;
  const renderConnector = () => <Connectors />;
  const renderSettings = () => <SettingsPage />;
  const renderMo3tiAdminDocumentRequests = () => <Mo3tiAdminDocumentRequests />;
  const renderMo3tiAdvancementManagement = () => <Mo3tiAdvancementManagement />;
  const renderAdminLeavePage = () => <LeaveApprovalPage />;
  const renderChangesPage = () => <EmployeeActionsPage />;
  const renderPayroll = () => <Payroll />;
  const renderTaxCalculator = () => <ExcelSalaryProcessorWithTheme />;
  const renderCompanyConfig = () => <CompanyConfiguration />;

  // دالة عرض الصفحات قيد التطوير
  const renderOtherPage = (pageName) => (
    <div>
      <div style={{ marginBottom: "32px" }}>
        <h1
          style={{
            color: theme === "light" ? "#0f172a" : "white",
            fontSize: "28px",
            fontWeight: "700",
            textAlign: isRTL ? "right" : "left",
            direction: isRTL ? "rtl" : "ltr",
          }}
        >
          {pageName}
        </h1>
        <p
          style={{
            color: theme === "light" ? "#64748b" : "rgba(255,255,255,0.8)",
            textAlign: isRTL ? "right" : "left",
            direction: isRTL ? "rtl" : "ltr",
          }}
        >
          {t.underDevelopment}
        </p>
      </div>
      <div
        style={{
          padding: "24px",
          background: theme === "light" ? "#fff" : "#1e293b",
          borderRadius: "16px",
          textAlign: "center",
        }}
      >
        <Settings size={64} />
        <h3 style={{ color: theme === "light" ? "#0f172a" : "white" }}>
          {pageName}
        </h3>
        <p
          style={{
            color: theme === "light" ? "#64748b" : "rgba(255,255,255,0.6)",
            direction: isRTL ? "rtl" : "ltr",
          }}
        >
          {t.pageWillContain}
          <br />
          {t.neededForEffective} {pageName.toLowerCase()} {t.management}
        </p>
      </div>
    </div>
  );

  // عرض الصفحة الحالية بناءً على التنقل
  const renderCurrentPage = () => {
    switch (currentPage) {
      case "dashboard":
        return renderDashboard();
      case "employees":
        return renderEmployees();
      case "analytics":
        return renderAnalytics();
      case "attendance":
        return renderAttendance();
      case "reports":
        return renderReports();
      case "calendar":
        return renderCalendar();
      case "messages": {
        // إذا لم يتم الحصول على الموقع بعد
        if (!userLocation && !locationError) {
          return <div style={{
            textAlign: "center",
            padding: "20px",
            direction: isRTL ? "rtl" : "ltr"
          }}>{t.locationAccessDenied}</div>;
        }

        if (locationError) {
          return (
            <div style={{
              color: "red",
              padding: "20px",
              textAlign: "center",
              direction: isRTL ? "rtl" : "ltr"
            }}>{locationError}</div>
          );
        }

        // حساب المسافة
        const distance = getDistance(
          userLocation.lat,
          userLocation.lng,
          allowedArea.lat,
          allowedArea.lng
        );

        if (distance > allowedArea.radius) {
          return (
            <div className="fixed inset-0 flex items-center justify-center z-50" style={{ direction: isRTL ? "rtl" : "ltr" }}>
              <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" />

              <div className="relative bg-white/80 dark:bg-slate-900/80 backdrop-blur-lg rounded-3xl shadow-2xl p-8 flex flex-col items-center max-w-xs text-center border border-red-400/20">
                <div className="w-24 h-24 flex items-center justify-center mb-5 relative">
                  <MapPinOff
                    size={60}
                    className="text-red-500/20 dark:text-red-400/20"
                  />
                  <div className="absolute inset-0 rounded-full bg-red-500/10 blur-xl animate-pulse" />
                </div>

                <h2 className="text-2xl font-extrabold text-red-600 dark:text-red-400 mb-2">
                  {t.accessRestricted}
                </h2>

                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  {t.outsideOfficeArea}
                </p>

                <div className="w-full bg-red-50/30 dark:bg-slate-800/30 rounded-xl p-4 mb-4 shadow-inner">
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
                    {t.distanceFromOffice}
                  </p>
                  <p className="text-xl font-bold text-gray-900 dark:text-gray-100">
                    {Math.round(distance).toLocaleString()}{" "}
                    <span className="text-sm font-medium">{t.meters}</span>
                  </p>
                </div>

                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {t.moveCloserToOffice}{" "}
                  <strong className="font-semibold text-gray-900 dark:text-gray-100">
                    {t.messages}
                  </strong>.
                </p>
              </div>
            </div>
          );
        }
        // مسموح → عرض صفحة الرسائل
        return renderMessages();
      }
      case "Settings":
        return renderSettings();
      case "Mo3tiAdminDocumentRequests":
        return renderMo3tiAdminDocumentRequests();
      case "Mo3tiAdvancementManagement":
        return renderMo3tiAdvancementManagement();
      case "Payroll":
        return renderPayroll();
      case "TaxCalculator":
        return renderTaxCalculator();
      case "LeaveApprovalPage":
        return renderAdminLeavePage();
      case "ChangesPage":
        return renderChangesPage();
      case "companyConfig":
        return renderCompanyConfig();
      default:
        return renderDashboard();
    }
  };

  // العرض الرئيسي
  return (
    <div
      style={{
        minHeight: "100vh",
        fontFamily: "Segoe UI, Roboto, sans-serif",
        position: "relative",
        direction: isRTL ? "rtl" : "ltr",
      }}
    >
      {/* خلفية الصورة */}
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
        <div
          style={{
            position: "absolute",
            top: "-140px",
            right: "-120px",
            width: "300px",
            height: "300px",
            borderRadius: "50%",
            filter: "blur(60px)",
            background:
              theme === "light"
                ? "rgba(59,130,246,0.05)"
                : "rgba(99,102,241,0.1)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-140px",
            left: "-140px",
            width: "320px",
            height: "320px",
            borderRadius: "50%",
            filter: "blur(60px)",
            background:
              theme === "light"
                ? "rgba(139,92,246,0.05)"
                : "rgba(59,130,246,0.1)",
          }}
        />
      </div>

      {/* الشريط الجانبي مع الشريط العلوي */}
      <SidebarWithTopbar
        navItems={navItems}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        user={user}
        notifications={notifications}
        handleLogout={handleLogout}
        handleSwitchEmployee={handleSwitchEmployee}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        themeToggle={
          <button
            style={{
              padding: "8px",
              borderRadius: "12px",
              cursor: "pointer",
              color: theme === "light" ? "#0f172a" : "white",
              background:
                theme === "light" ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
            }}
            onClick={toggleTheme}
          >
            {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
          </button>
        }
        viewModeSwitcher={
          <ViewTypeSwitcher
            viewType={viewType}
            onSelect={(type) => {
              handleViewTypeChange(type);
            }}
            hasAdminLevel={() => hasAdminLevel()}
            role={user.role}
          />
        }
      >
        <div style={{
          padding: "0",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          marginTop: 40,
          direction: isRTL ? "rtl" : "ltr",
        }}>
          <Routes>
            <Route path="/dashboard" element={renderDashboard()} />
            <Route path="/employees" element={renderEmployees()} />
            <Route path="/attendance" element={renderAttendance()} />
            <Route path="/analytics" element={renderAnalytics()} />
            <Route path="/reports" element={renderReports()} />
            <Route path="/calendar" element={renderCalendar()} />
            <Route
              path="/messages"
              element={
                modulePermissions === null ? (
                  <div style={{ padding: 20, textAlign: "center" }}>Loading...</div>
                ) : isPrivateMessagingEnabled ? (
                  <MessengerPage />
                ) : (
                  <Navigate to="/DashboardManager/dashboard" replace />
                )
              }
            />


            <Route path="/Mo3tiAdminDocumentRequests" element={renderMo3tiAdminDocumentRequests()} />
            <Route path="/Mo3tiAdvancementManagement" element={renderMo3tiAdvancementManagement()} />
            <Route path="/Payroll" element={renderPayroll()} />
            <Route path="/TaxCalculator" element={renderTaxCalculator()} />
            <Route path="/LeaveApprovalPage" element={renderAdminLeavePage()} />
            <Route path="/ChangesPage" element={renderChangesPage()} />
            <Route path="/companyConfig" element={renderCompanyConfig()} />
            <Route path="/Settings" element={renderSettings()} />
            <Route path="*" element={<Navigate to="/DashboardManager" replace />} />
          </Routes>
        </div>
      </SidebarWithTopbar>
    </div>
  );
}

export default ProfessionalDashboardManager;